import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { tableDataTableStyles } from "./DataTable";

export function DataTableAASHTOHeader({ item }) {
  const { t } = useTranslation("translation");
  let isMetric = item.measurementType == 0;

  return (
    <>
      <View style={tableDataTableStyles.headerRow_Table}>
        {/* Layer Description */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Layer description_1")}</Text>
        {/* Windening */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Widening")}</Text>
        {/* Layer Top */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Layer top")}</Text>
        {/* Layer Bottom */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Layer bottom")}</Text>
        {/* Inclined length */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Inclined length")}</Text>
        {/* Scin friction */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Skin friction")}</Text>
        {/* Load taken in Layer */}
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Load taken in layer")}</Text>
      </View>

      <View style={tableDataTableStyles.headerRowBottom}>
        <Text style={tableDataTableStyles.title}>{t("aashto.ausser.Layer description_2")}</Text>
        <Text style={tableDataTableStyles.title}>[{isMetric ? "mm" : "in"}]</Text>
        <Text style={tableDataTableStyles.title}>[{isMetric ? "m" : "ft"}]</Text>
        <Text style={tableDataTableStyles.title}>[{isMetric ? "m" : "ft"}]</Text>
        <Text style={tableDataTableStyles.title}>[{isMetric ? "m" : "ft"}]</Text>
        <Text style={tableDataTableStyles.title}>[{isMetric ? "kN/m²" : "ksf"}]</Text>
        <Text style={tableDataTableStyles.title}>[{isMetric ? "kN" : "kip"}]</Text>
      </View>
    </>
  );
}
